import { Stack } from "@fluentui/react";
import { useNavigate } from "react-router";
import React, { useEffect, useState } from "react";
import { useAppContext } from "./AppContext";
import ActionButton from "./ActionButton";
import SConsciousApiService from "../services/SConsciousApiService";

const api = new SConsciousApiService();

export default function Menu() {

    const { appData } = useAppContext();
    const navigate = useNavigate();
    const signedIn = localStorage.getItem('signed_in') === 'true';
    const userEmail = localStorage.getItem('signed_in_email') || '';
    const userId = localStorage.getItem('signed_in_id') || '';
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        if (userId) api.adminCheck(userId).then(setIsAdmin);
    }, [userId]);

    return ( 

        <Stack className="menu-container">
            <Stack className="menu">
                <br/>
                <ActionButton label="Home" onClick={() => navigate("/")} />
                <ActionButton label="Features" onClick={() => navigate("/Features")} />
                <br/>
                {signedIn && (
                    <>
                        <ActionButton label="Reports" onClick={() => navigate("/Reports")} />
                        <ActionButton label="Upload" onClick={() => navigate("/Camera?p=Upload")} />
                        <ActionButton label="Feedback" onClick={() => navigate("/Feedback")} />
                    </> 
                )}
                <br/>
                {isAdmin && <ActionButton label="Admin Portal" onClick={() => navigate("/Admin")} />}
                <br/>
                <br/>
                <br/>
                <p>Version: {appData?.data?.version}</p>
            </Stack>
        </Stack>
    )

}